/* istanbul ignore file */
import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GetStartedModalComponent } from 'src/app/shared/components/get-started-modal/get-started-modal.component';

@Component({
  selector: 'app-disclaimer-section',
  templateUrl: './disclaimer-section.component.html',
  styleUrls: ['./disclaimer-section.component.scss']
})
export class DisclaimerSectionComponent{
  needHelpText:string;
  viewTutorialLabel:string;

  constructor(
    private matDialog: MatDialog
  ) { }


  openTutorial() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.ariaLabel = 'Get Started Dialog';
    dialogConfig.id = 'get-started-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      title: 'Account',
      content: '',
      buttonText: 'Next'
    };

    this.matDialog.open(GetStartedModalComponent, dialogConfig);
  }
}
